import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const SliderAreasOfPracticeCMS = () => {
  const [imageAreasOfPractice, setImageAreasOfPractice] = useState([]);
  const [textAreasOfPractice, setTextAreasOfPractice] = useState([]);
  const [newImage, setNewImage] = useState(null);
  const [newText, setNewText] = useState('');
  const [addSuccessMessage, setAddSuccessMessage] = useState('');
  const [addError, setAddError] = useState('');
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState('');
  const [updateError, setUpdateError] = useState('');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [areaOfPracticeToDelete, setAreaOfPracticeToDelete] = useState(null);
  const [editingImageAreaOfPractice, setEditingImageAreaOfPractice] = useState(null);
  const [editingTextAreaOfPractice, setEditingTextAreaOfPractice] = useState(null);
  const [ImageErrorUpdate, setImageErrorUpdate] = useState('');

  useEffect(() => {
    fetchAreasOfPracticeImages();
    fetchAreasOfPracticeTexts();
  }, []);

  const fetchAreasOfPracticeImages = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderAreaOfPractice/listImages');
      setImageAreasOfPractice(response.data.data);
    } catch (error) {
      console.error('Error fetching areas of practice images:', error);
    }
  };

  const fetchAreasOfPracticeTexts = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderAreaOfPractice/listTexts');
      setTextAreasOfPractice(response.data.data);
    } catch (error) {
      console.error('Error fetching areas of practice texts:', error);
    }
  };

  const addAreaOfPracticeImage = async () => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.post('https://back.zubilaw.com/SliderAreaOfPractice/addImage', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setAddSuccessMessage('Area of practice image added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewImage(null);
      fetchAreasOfPracticeImages();
    } catch (error) {
      setAddError('Please select an image to upload.');
      console.error('Error adding area of practice image:', error);
    }
  };

  const addAreaOfPracticeText = async () => {
    const data = {
      text: newText,
    };

    try {
      await axios.post('https://back.zubilaw.com/SliderAreaOfPractice/addText', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setAddSuccessMessage('Area of practice text added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewText('');
      fetchAreasOfPracticeTexts();
    } catch (error) {
      setAddError('Please enter text to add.');
      console.error('Error adding area of practice text:', error);
    }
  };

  const updateAreaOfPracticeImage = async (id) => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.put(`https://back.zubilaw.com/SliderAreaOfPractice/updateImage/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setUpdateSuccessMessage('Area of practice image updated successfully!');
      setEditingImageAreaOfPractice(null);
      setNewImage(null);
      fetchAreasOfPracticeImages();
    } catch (error) {
      setUpdateError('Error updating area of practice image.');
      console.error('Error updating area of practice image:', error);
    }
  };

  const updateAreaOfPracticeText = async (id) => {
    const data = {
      text: newText,
    };

    try {
      await axios.put(`https://back.zubilaw.com/SliderAreaOfPractice/updateText/${id}`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setUpdateSuccessMessage('Area of practice text updated successfully!');
      setEditingTextAreaOfPractice(null);
      setNewText('');
      fetchAreasOfPracticeTexts();
    } catch (error) {
      setUpdateError('Error updating area of practice text.');
      console.error('Error updating area of practice text:', error);
    }
  };

  const deleteAreaOfPractice = (id) => {
    setAreaOfPracticeToDelete(id);
    setShowDeletePopup(true);
  };

  const performDelete = async () => {
    try {
      await axios.delete(`https://back.zubilaw.com/SliderAreaOfPractice/delete/${areaOfPracticeToDelete}`);
      setShowDeletePopup(false);
      fetchAreasOfPracticeImages();
      fetchAreasOfPracticeTexts();
    } catch (error) {
      console.error('Error deleting area of practice:', error);
    }
  };

  const closeUpdateForm = () => {
    setEditingImageAreaOfPractice(null);
    setEditingTextAreaOfPractice(null);
    setNewImage(null);
    setNewText('');
  };

  const modules = {
    toolbar: [
      [{ 'color': [] }, { 'background': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': '1' }, { 'header': '2' }, { 'header': [3, 4, 5, 6] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']                                         
    ],
  };
  
  const formats = [
    'background', 'color', 'bold', 'italic', 'underline', 'strike', 'header',
    'list', 'bullet', 'align', 'link', 'image', 'video'
  ];

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Manage Areas of Practice Images</CardTitle>
            </CardHeader>
            <CardBody>
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Image</label>
                      <Input
                        type="file"
                        onChange={(e) => setNewImage(e.target.files[0])}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addAreaOfPracticeImage}
                    >
                      Add Area of Practice Image
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form>
              <Table responsive>
  <thead className="text-primary">
    <tr>
      <th>Image</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {imageAreasOfPractice.map((areaOfPractice, index) => (
      <tr key={areaOfPractice.id}>
        <td>
          <img
            src={`https://back.zubilaw.com/${areaOfPractice.slider}`}
            alt="Area of Practice Slider"
            style={{ maxWidth: '300px', maxHeight: '200px' }}
          />
        </td>
        <td>
          <Button
            color="success"
            onClick={() => {
              setEditingImageAreaOfPractice(areaOfPractice);
              setNewImage(null);
            }}
          >
            Update Image
          </Button>{" "}
          {index !== 0 && (
            <Button
              color="danger"
              onClick={() => deleteAreaOfPractice(areaOfPractice.id)}
            >
              Delete
            </Button>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</Table>

            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Text Details</CardTitle>
            </CardHeader>
            <CardBody>
              {/* <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Text</label>
                      <Input
                        type="text"
                        value={newText}
                        onChange={(e) => setNewText(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addAreaOfPracticeText}
                    >
                      Add Area of Practice Text
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form> */}
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>Text</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
  {textAreasOfPractice.map((areaOfPractice) => (
    <tr key={areaOfPractice.id}>
      <td dangerouslySetInnerHTML={{ __html: areaOfPractice.text }}></td>
      <td>
        <Button
          color="success"
          onClick={() => {
            setEditingTextAreaOfPractice(areaOfPractice);
            setNewText(areaOfPractice.text);
          }}
        >
          Update Text
        </Button>{" "}
        {/* <Button
          color="danger"
          onClick={() => deleteAreaOfPractice(areaOfPractice.id)}
        >
          Delete
        </Button> */}
      </td>
    </tr>
  ))}
</tbody>

              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {(editingImageAreaOfPractice || editingTextAreaOfPractice) && (
        <CardFooter>
          <Form>
            <Row>
            {editingTextAreaOfPractice && (
  <Col md="6">
    <FormGroup>
      <label>Text</label>
      <div
      style={{
        height: '300px', // Adjust the height as needed
        overflowY: 'auto', // Add a vertical scrollbar when content overflows
      }}
    >
      <ReactQuill
        value={newText}
        onChange={setNewText}
      modules={modules} 
      formats={formats}
      style={{ height: '80%', color: 'black' }}
      />
    </div>
    </FormGroup>
  </Col>
)}


              {editingImageAreaOfPractice && (
                <Col md="6">
                  <FormGroup>
                    <label>Image</label>
                    <Input
                      type="file"
                      onChange={(e) => setNewImage(e.target.files[0])}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md="12">
                {editingTextAreaOfPractice && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateAreaOfPracticeText(editingTextAreaOfPractice.id)}
                  >
                    Update Text
                  </Button>
                )}{" "}
                {editingImageAreaOfPractice && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateAreaOfPracticeImage(editingImageAreaOfPractice.id)}
                  >
                    Update Image
                  </Button>
                )}{" "}
                <Button
                  className="btn-round"
                  color="secondary"
                  onClick={closeUpdateForm}
                >
                  Cancel
                </Button>
                {updateSuccessMessage && (
                  <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateSuccessMessage}
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateError}
                  </div>
                )}
                {ImageErrorUpdate && (
                  <div style={{ color: 'red' }}>
                    {ImageErrorUpdate}
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </CardFooter>
      )}

      <Modal isOpen={showDeletePopup} toggle={() => setShowDeletePopup(false)}>
        <ModalHeader toggle={() => setShowDeletePopup(false)}>Delete Area of Practice</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this area of practice?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={performDelete}>Delete</Button>
          <Button color="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SliderAreasOfPracticeCMS;
